export class SDKError extends Error {
    constructor(message) {
        super(`[sdk]: ${message}`);
    }
}
//# sourceMappingURL=error.js.map